import { Injectable } from "@angular/core";
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from "@angular/fire/database";
import { SurveyTypeEnum } from "../enums/surveyType.enum";

@Injectable({
  providedIn: "root",
})
export class BranchesService {
  constructor(private firebase: AngularFireDatabase) {}

  branchesRef: AngularFireList<any> = null;

  getBranchesList(surveyType: SurveyTypeEnum): AngularFireList<any> {
    const surveyTable = surveyType == SurveyTypeEnum.CUSTOMER ? "CX" : "EX";

    this.branchesRef = this.firebase.list(`/Branches/${surveyTable}`);
    return this.branchesRef;
  }
}
